import meldingenArchief from "../data/meldingen-archief.json";

interface Melding {
  tijd: string;
  melder: string | null;
  bericht: string;
  uitgezet_naar: string | null;
  afhandeling: string | null;
}

const archief = meldingenArchief as {
  datum: string;
  evenement: string;
  opdrachtgever?: string;
  cp_team: { naam: string; functie: string; afkorting: string }[];
  noot_afkortingen: string;
  meldingen: Melding[];
};

export function Logboek() {
  const total = archief.meldingen.length;

  return (
    <div className="space-y-4">
      <div
        className="rounded-2xl bg-ink-925 p-4"
        style={{ border: "1px solid rgba(255,255,255,0.06)" }}
      >
        <div className="flex items-center gap-2 mb-3">
          <span className="w-1.5 h-1.5 rounded-full bg-zinc-600" />
          {/* TODO(scott-call): datum invullen, bijv. "CPC Logboek · 12 sep 2026" */}
          <span className="text-2xs tracking-eyebrow uppercase text-zinc-500">
            CPC Logboek · archief
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3 pb-3 mb-3 border-b border-white/[0.05]">
          <div>
            <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
              Event
            </div>
            <div className="text-zinc-100 text-sm font-medium mt-0.5 leading-tight">
              {archief.evenement}
            </div>
          </div>
          {archief.opdrachtgever && (
            <div>
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                Opdrachtgever
              </div>
              <div className="text-zinc-100 text-sm font-medium mt-0.5">
                {archief.opdrachtgever}
              </div>
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 gap-3">
          {archief.cp_team.map((p) => (
            <div key={p.afkorting}>
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                {p.functie}
              </div>
              <div className="text-zinc-100 text-sm font-medium mt-0.5">
                {p.naam}
              </div>
              <div className="text-2xs text-zinc-500 mt-0.5 tabular">
                {p.afkorting}
              </div>
            </div>
          ))}
        </div>
        <p className="text-2xs text-zinc-600 mt-3 leading-relaxed">
          {archief.noot_afkortingen}
        </p>
      </div>

      <a
        href="/docs/cp-log.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-between rounded-2xl px-4 py-3 transition-colors"
        style={{
          background: "rgba(255,255,255,0.025)",
          border: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <div className="flex items-center gap-3 min-w-0">
          <span
            className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
            style={{
              background: "rgba(94,234,212,0.08)",
              border: "1px solid rgba(94,234,212,0.22)",
            }}
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-4 h-4 text-accent"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6" />
            </svg>
          </span>
          <div className="min-w-0">
            <div className="text-zinc-100 text-sm font-medium leading-tight truncate">
              Origineel CP-logboek
            </div>
            <div className="text-2xs text-zinc-500 mt-0.5 truncate">
              260505 — CPH log BFH 2026 · PDF
            </div>
          </div>
        </div>
        <span className="text-2xs text-zinc-500 group-hover:text-accent shrink-0 ml-3">
          Open ↗
        </span>
      </a>

      <div className="flex items-baseline justify-between px-1 pt-1">
        <h3 className="text-2xs tracking-eyebrow uppercase font-semibold text-zinc-300">
          Meldingen
        </h3>
        <span className="text-2xs text-zinc-500 tabular">
          {total} · 11:00 — 23:48
        </span>
      </div>

      <ol className="space-y-1.5">
        {archief.meldingen.map((m, i) => (
          <li
            key={`${m.tijd}-${i}`}
            className="rounded-xl bg-ink-925 px-3 py-2.5"
            style={{ border: "1px solid rgba(255,255,255,0.04)" }}
          >
            <div className="flex items-start gap-3">
              <div className="text-accent text-2xs tabular font-semibold tracking-tight pt-0.5 w-12 shrink-0">
                {m.tijd}
              </div>
              <div className="flex-1 min-w-0">
                {m.melder && (
                  <div className="text-2xs tracking-eyebrow uppercase text-zinc-500 mb-0.5">
                    {m.melder}
                  </div>
                )}
                <div className="text-zinc-100 text-sm leading-snug">
                  {m.bericht}
                </div>
                {(m.uitgezet_naar || m.afhandeling) && (
                  <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1.5">
                    {m.uitgezet_naar && (
                      <span className="text-2xs text-zinc-500">
                        <span className="text-zinc-600">→ </span>
                        {m.uitgezet_naar}
                      </span>
                    )}
                    {m.afhandeling && (
                      <span className="text-2xs text-zinc-500">
                        <span className="text-zinc-600">✓ </span>
                        {m.afhandeling}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
